import { useI18n } from '../../../i18n';
import { cn } from '../../../utils/cn';

// ============================================
// Types
// ============================================

interface SmartInsightsCardProps {
  title?: string;
  body: string;
  className?: string;
}

// ============================================
// Component
// ============================================

export function SmartInsightsCard({
  title,
  body,
  className,
}: SmartInsightsCardProps) {
  const { t } = useI18n();
  const displayTitle = title || t('smartInsights') || 'Smart Insights';

  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-xl p-5',
        className
      )}
      style={{ backgroundColor: 'rgba(225, 226, 237, 0.4)' }}
    >
      {/* Decorative icon - top right, partially clipped */}
      <div className="pointer-events-none absolute -top-4 -right-4 h-20 w-20 opacity-10">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="h-full w-full"
        >
          <path
            d="M12 2L14.09 8.26L21 9.27L16 14.14L17.18 21.02L12 17.77L6.82 21.02L8 14.14L3 9.27L9.91 8.26L12 2Z"
            fill="#004AC6"
          />
        </svg>
      </div>

      {/* Content */}
      <div className="relative z-10">
        {/* Title */}
        <h4 className="text-sm font-bold text-[#191B23]">{displayTitle}</h4>

        {/* Body */}
        <p className="mt-2 text-xs leading-relaxed text-[#434655]">{body}</p>
      </div>
    </div>
  );
}
